<!--
Attributes： 
图片地址url（必传）: 类型字符串
图片类型outputType（可选）：默认png,(可以传值常见图片类型)，；类型字符串
裁剪后返回图片大小cutSizi(可选)：默认：{w: 裁剪框的宽, h: 裁剪框的高} ；类型object
实时裁剪isRealTime（可选）: 默认true(接受传值： true,flase), 类型布尔值（参数说明：如果传入ture，裁剪框每次移动或改变大小实时裁剪图片，false表示在鼠标抬起之后才裁剪图片）
裁剪框操作点的颜色dotColor(可选)：默认white
裁剪框操作点的大小dotSize(可选)：默认12px 接受字符串类型
字体颜色fontColor(可选)：默认值rgba(59, 57, 57, 0.685)
字体大小fontSize(可选)：默认值：容器宽度 * 0.1 接受字符串类型
-->
<!--
Events:
@resultCallback; 回调参数:file文件对象
!-->
<template>
  <div class="xz-cutMachine-myCut" ref="myCut">
    <div v-show="url" class="xz-cutMachine-imgBox" ref="parentDom">
      <div ref="sourceImg" class="xz-cutMachine-img">
        <img ref="imgRef" id="dynamicImage" style="height: 100%; width: 100%;" :src="url" alt="" />
        <canvas class="xz-cutMachine-canvasRect" ref="canvasRect"></canvas>
        <span ref="leftTop" @mousedown.self="LTchange('leftTop', $event)"
          class="xz-cutMachine-leftTop xz-cutMachine-dot"></span>
        <span ref="rightTop" @mousedown.self="LTchange('rightTop', $event)"
          class="xz-cutMachine-rightTop xz-cutMachine-dot"></span>
        <span ref="leftBottom" @mousedown.self="LTchange('leftBottom', $event)"
          class="xz-cutMachine-leftBottom xz-cutMachine-dot"></span>
        <span ref="rightBottom" @mousedown.self="LTchange('rightBottom', $event)"
          class="xz-cutMachine-rightBottom xz-cutMachine-dot"></span>
        <div @mouseover.self="mouseoverBogus" ref="bogus" class="xz-cutMachine-bogus"></div>
      </div>
    </div>
    <div v-show="!url" class="xz-cutMachine-text">请选择图片</div>
  </div>
</template>

<script>
export default {
  name: "xz-cutMachine", //组件名 前缀都要加 xz-
  props: {
    url: {
      type: String,
      default: "",
    },
    outputType: {
      type: String,
      default: "png",
    },
    isRealTime: {
      type: Boolean,
      default: true,
    },
    cutSizi: {
      type: Object,
      default: () => {
        return {
          w: 0,
          h: 0
        }
      }
    },
    dotColor: {
      type: String,
      default: 'yellow'
    },
    dotSize: {
      type: String,
      default: '12px'
    },
    fontColor: {
      type: String,
      default: 'rgba(59, 57, 57, 0.685)'
    },
    fontSize: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      myCut: null,
      parentDom: null, // 定位父元素
      sourceImg: null, // 图片img元素
      realWidthL: 0,   // 图片的真实宽度
      realHeight: 0,   // 图片的真实高度
      ctx: null,
      picName: '',
      bogus: null, // 虚假的遮罩层
      lock: true,
    };
  },
  computed: {},
  watch: {
    url: {
      immediate: true,
      handler(val) {
        if (val) {
          let image = new Image();
          image.src = val;
          image.onload = () => {
            this.realWidth = image.naturalWidth || image.width;  // 获取图片的真实宽度
            this.realHeight = image.naturalHeight || image.height; // 获取图片的真实高度
            this.centerImage(image.naturalWidth, image.naturalHeight);
            this.initCutDotPosition()
            this.initCanvas()
            this.picName = this.generateRandomString(16)
            this.cropping()
          };
        }
      },
    },
    dotColor: {
      immediate: true,
      handler(val) {
        this.$nextTick(() => {
          val = val ? val : 'yellow';
          this.myCut && this.myCut.style.setProperty("--dotColor", val); // 设置操作点的颜色
        })
      }
    },
    dotSize: {
      immediate: true,
      handler(val) {
        this.$nextTick(() => {
          val = val ? val : '12px';
          this.myCut && this.myCut.style.setProperty("--dotSize", val);
        })
      }
    },
    fontColor: {
      immediate: true,
      handler(val) {
        this.$nextTick(() => {
          val = val ? val : 'rgba(59, 57, 57, 0.685)';
          this.myCut && this.myCut.style.setProperty("--fontColor", val);
        })
      }
    },
    fontSize: {
      immediate: true,
      handler(val) {
        this.$nextTick(() => {
          let sizi = val ? val : this.myCut.offsetWidth * 0.1 + 'px'
          this.myCut && this.myCut.style.setProperty("--fontSize", sizi);
        })
      }
    }
  },
  created() {
  },
  mounted() {
    this.myCut = this.$refs.myCut
    this.parentDom = this.$refs.parentDom;
    this.parentDomWidth = this.parentDom.offsetWidth
    this.parentDomHeight = this.parentDom.offsetHeight
    this.sourceImg = this.$refs.sourceImg
    this.canvasRect = this.$refs.canvasRect
    this.leftTop = this.$refs.leftTop
    this.rightTop = this.$refs.rightTop
    this.leftBottom = this.$refs.leftBottom
    this.rightBottom = this.$refs.rightBottom
    this.bogus = this.$refs.bogus
    this.initCutDotCursor()
    this.bogus.addEventListener("mousedown", this.mousedownCanvas);
  },
  methods: {
    // 处理伪造的裁剪框大小定位
    setBogus(x, y, w, h) {
      this.myCut.style.setProperty("--BogusX", x + 'px');
      this.myCut.style.setProperty("--BogusY", y + 'px');
      this.myCut.style.setProperty("--BogusW", w + 'px');
      this.myCut.style.setProperty("--BogusH", h + 'px');
    },
    // 进入裁剪框鼠标手势
    mouseoverBogus() {
      this.myCut.style.setProperty("--cursor", 'move');
    },
    // 初始化四个操作点的手势
    initCutDotCursor() {
      this.myCut && this.myCut.style.setProperty("--cursor14", 'nw-resize');
      this.myCut && this.myCut.style.setProperty("--cursor23", 'ne-resize');
    },
    // 设置四个操作点的手势
    setDotCursor(tag, dotInfo, currentPosition) {
      // 点击操作的是：左上点和右下点
      if ((tag == 'leftTop' || tag == 'rightBottom') && ((currentPosition.x > dotInfo.bottomLeft.x && currentPosition.y < dotInfo.bottomLeft.y) || (currentPosition.x < dotInfo.topRight.x && currentPosition.y > dotInfo.topRight.y))) {
        this.myCut && this.myCut.style.setProperty("--cursor14", 'ne-resize');
        this.myCut && this.myCut.style.setProperty("--cursor23", 'nw-resize');
      }
      if ((tag == 'leftTop' || tag == 'rightBottom') && ((currentPosition.x < dotInfo.bottomRight.x && currentPosition.y < dotInfo.bottomRight.y) || (currentPosition.x > dotInfo.topLeft.x && currentPosition.y > dotInfo.topLeft.y))) {
        this.myCut && this.myCut.style.setProperty("--cursor14", 'nw-resize');
        this.myCut && this.myCut.style.setProperty("--cursor23", 'ne-resize');
      }
      // 点击操作的是：右上点和左下点
      if ((tag == 'rightTop' || tag == 'leftBottom') && ((currentPosition.x > dotInfo.bottomLeft.x && currentPosition.y < dotInfo.bottomLeft.y) || (currentPosition.x < dotInfo.topRight.x && currentPosition.y > dotInfo.topRight.y))) {
        this.myCut && this.myCut.style.setProperty("--cursor14", 'nw-resize');
        this.myCut && this.myCut.style.setProperty("--cursor23", 'ne-resize');
      }
      if ((tag == 'rightTop' || tag == 'leftBottom') && ((currentPosition.x < dotInfo.bottomRight.x && currentPosition.y < dotInfo.bottomRight.y) || (currentPosition.x > dotInfo.topLeft.x && currentPosition.y > dotInfo.topLeft.y))) {
        this.myCut && this.myCut.style.setProperty("--cursor14", 'ne-resize');
        this.myCut && this.myCut.style.setProperty("--cursor23", 'nw-resize');
      }
    },
    // 初始化裁剪点的定位
    initCutDotPosition() {
      // 左上 右上 左下 右下
      this.leftTop.style.left = 0;
      this.leftTop.style.top = 0;

      this.rightTop.style.left = this.sourceImg.offsetWidth / 2 + 'px';
      this.rightTop.style.top = 0;

      this.leftBottom.style.left = 0;
      this.leftBottom.style.top = this.sourceImg.offsetHeight / 2 + 'px';

      this.rightBottom.style.left = this.sourceImg.offsetWidth / 2 + 'px';
      this.rightBottom.style.top = this.sourceImg.offsetHeight / 2 + 'px';
    },
    // 初始化画布
    initCanvas() {
      const width = this.leftTop.clientWidth / 2  // 原点的大小的一半
      const x = this.leftTop.offsetLeft + width
      const y = this.leftTop.offsetTop + width
      const w = this.rightTop.offsetLeft - this.leftTop.offsetLeft
      const h = this.leftBottom.offsetTop - this.leftTop.offsetTop
      this.canvasRect.width = this.sourceImg.getBoundingClientRect().width;
      this.canvasRect.height = this.sourceImg.getBoundingClientRect().height;
      // / 1. 创建画布
      this.ctx = this.canvasRect.getContext("2d");
      // 绘制开始
      this.ctx.fillStyle = 'rgba(0, 0, 0, .8)'; // 透明度控制遮罩暗度
      this.ctx.fillRect(0, 0, this.canvasRect.width, this.canvasRect.height);

      // 3. 使用混合模式"擦除"矩形区域
      this.ctx.globalCompositeOperation = 'destination-out'; // 使后续绘制变透明
      this.ctx.fillRect(x, y, w, h); // 绘制你的高亮区域
      // 4. 恢复混合模式（重要！）
      this.ctx.globalCompositeOperation = 'source-over';

      this.setBogus(x, y, w, h) // 制造一个虚假的裁剪框
    },
    // 绘制裁剪框矩形
    drawRect(x, y, w, h) {
      this.ctx.clearRect(0, 0, this.ctx.width, this.ctx.height) // 清空矩形
      this.ctx.width = this.sourceImg.getBoundingClientRect().width;
      this.ctx.height = this.sourceImg.getBoundingClientRect().height;
      // 2. 绘制全屏半透明黑色遮罩
      this.ctx.fillStyle = 'rgba(0, 0, 0, .8)'; // 透明度控制遮罩暗度
      this.ctx.fillRect(0, 0, this.canvasRect.width, this.canvasRect.height);

      // 3. 使用混合模式"擦除"矩形区域
      this.ctx.globalCompositeOperation = 'destination-out'; // 使后续绘制变透明
      this.ctx.fillRect(x, y, w, h); // 绘制你的高亮区域
      // this.ctx.stroke();
      // 4. 恢复混合模式（重要！）
      this.ctx.globalCompositeOperation = 'source-over';

      this.setBogus(x, y, w, h) // 制造一个虚假的裁剪框
    },
    // 拖动裁剪框的方法
    mousedownCanvas(e) {
      const { topLeft, bottomRight } = this.getTopLeftCoordinate()
      const sourceImg = this.sourceImg.getBoundingClientRect()
      // const leftTop
      const widthHalf = this.leftTop.clientWidth / 2 //宽的一半
      // isX 行坐标判断是否在裁剪框内
      const isX1 = e.clientX > topLeft.x + widthHalf + sourceImg.left
      const isX2 = e.clientX < bottomRight.x + widthHalf + sourceImg.left
      // isY 列坐标判断是否在裁剪框内
      const isY1 = e.clientY > topLeft.y + widthHalf + sourceImg.top
      const isY2 = e.clientY < bottomRight.y + widthHalf + sourceImg.top
      if (!(isX1 && isX2 && isY1 && isY2)) {
        return
      }
      // 裁剪框大小
      const width = bottomRight.x - topLeft.x
      const height = bottomRight.y - topLeft.y
      // 左上
      const x1 = e.clientX - topLeft.x;
      const y1 = e.clientY - topLeft.y;
      // const arr = ['leftTop', 'rightTop', 'leftBottom', 'rightBottom',]
      // 拖动
      window.onmousemove = (e) => {
        // const {topLeft, bottomRight} = this.getTopLeftCoordinate()
        let _h = sourceImg.height
        let _w = sourceImg.width
        // 左上
        let disX1 = e.clientX - x1
        let disY1 = e.clientY - y1

        disX1 = Math.min(Math.max(0 - widthHalf, disX1), _w - width - widthHalf)
        disY1 = Math.min(Math.max(0 - widthHalf, disY1), _h - height - widthHalf)

        // 右上
        const disX2 = disX1 + width
        const disY2 = disY1
        // 左下
        const disX3 = disX1
        const disY3 = disY1 + height
        // 右下
        const disX4 = disX1 + width
        const disY4 = disY1 + height

        this.leftTop.style.left = disX1 + 'px'
        this.leftTop.style.top = disY1 + 'px'

        this.rightTop.style.left = disX2 + 'px'
        this.rightTop.style.top = disY2 + 'px'

        this.leftBottom.style.left = disX3 + 'px'
        this.leftBottom.style.top = disY3 + 'px'

        this.rightBottom.style.left = disX4 + 'px'
        this.rightBottom.style.top = disY4 + 'px'

        // 重新绘制矩形
        this.drawRect(disX1 + widthHalf, disY1 + widthHalf, width, height)
        // 重新初始化四个点鼠标样式
        this.initCutDotCursor()
        this.isRealTime && this.cropping()
      };

      window.onmouseup = () => {
        // 鼠标抬起
        !this.isRealTime && this.cropping()
        window.onmousemove = null
        window.onmouseup = null;
      };
    },
    // 裁剪框修改大小的方法
    LTchange(tag) {
      const widthHalf = this.leftTop.clientWidth / 2 //宽的一半
      const sourceImgRect = this.sourceImg.getBoundingClientRect()
      window.onmousemove = (e) => {
        // 点的位置 = 鼠标位置-图片位置-宽的一半
        const x = e.clientX - sourceImgRect.left - widthHalf
        const y = e.clientY - sourceImgRect.top - widthHalf
        // 重新定义当前点的坐标
        this[tag].style.left = x >= - widthHalf && x <= sourceImgRect.width - widthHalf && x + "px";
        this[tag].style.top = y >= - widthHalf && y <= sourceImgRect.height - widthHalf && y + "px";
        if (tag == 'leftTop') {
          // 重新定位左下点的X坐标位置
          this.leftBottom.style.left = this.leftTop.style.left;
          // 重新定位右上点的Y坐标位置
          this.rightTop.style.top = this.leftTop.style.top;
        }
        if (tag == 'rightTop') {
          // 重新定义左上点的Y坐标位置
          this.leftTop.style.top = this.rightTop.style.top;
          // 重新定义右下点的X坐标位置
          this.rightBottom.style.left = this.rightTop.style.left;
        }
        if (tag == 'leftBottom') {
          // 重新定义左上点的X坐标位置
          this.leftTop.style.left = this.leftBottom.style.left;
          // 重新定义右下点的Y坐标位置
          this.rightBottom.style.top = this.leftBottom.style.top;
        }
        if (tag == 'rightBottom') {
          // 重新定义右上点的X坐标位置
          this.rightTop.style.left = this.rightBottom.style.left;
          // 重新定义左下点的Y坐标位置
          this.leftBottom.style.top = this.rightBottom.style.top;
        }
        const { topLeft, bottomLeft, topRight, bottomRight } = this.getTopLeftCoordinate()
        this.setDotCursor(tag, { topLeft, bottomLeft, topRight, bottomRight }, { x, y })
        this.drawRect(topLeft.x + widthHalf, topLeft.y + widthHalf, Math.abs(this.leftTop.offsetLeft - this.rightTop.offsetLeft), Math.abs(this.leftTop.offsetTop - this.leftBottom.offsetTop))
        this.isRealTime && this.cropping()
      };
      window.onmouseup = () => {
        this.cropping()
        !this.isRealTime && this.cropping()
        window.onmousemove = null;
        window.onmouseup = null;
      };
    },
    // 找出最左上角的点中心点作为裁剪框的左上角
    getTopLeftCoordinate(points) {
      // 找出最左上角的点中心点作为裁剪框的左上角
      points = points || [
        { x: this.leftTop.offsetLeft, y: this.leftTop.offsetTop },
        { x: this.leftBottom.offsetLeft, y: this.leftBottom.offsetTop },
        { x: this.rightTop.offsetLeft, y: this.rightTop.offsetTop },
        { x: this.rightBottom.offsetLeft, y: this.rightBottom.offsetTop }
      ];
      // 按x升序、y升序排序
      points.sort((a, b) => a.x - b.x || a.y - b.y);

      // 分离左右两组（基于x最小值/最大值）
      const minX = points[0].x;
      const maxX = points[3].x;
      const leftGroup = points.filter(p => p.x === minX);
      const rightGroup = points.filter(p => p.x === maxX);

      // 处理左右组中的坐标分配
      const processGroup = group => ({
        top: group.reduce((min, p) => p.y < min.y ? p : min, group[0]),
        bottom: group.reduce((max, p) => p.y > max.y ? p : max, group[0])
      });

      // 获取最终分配结果
      const left = processGroup(leftGroup);
      const right = processGroup(rightGroup);

      return {
        topLeft: left.top,
        bottomLeft: left.bottom,
        topRight: right.top,
        bottomRight: right.bottom
      };
    },
    // 图片不同格式显示 宽>高 宽<高 宽=高
    centerImage(width, height) {

      if (height > width) {
        this.sourceImg.style.height = "100%";
        this.sourceImg.style.width = 'auto'
        this.sourceImg.style.top = "0";
        this.sourceImg.style.left = (this.parentDom.offsetWidth - this.sourceImg.offsetWidth) / 2 + 'px';
      } else if (width > height) {
        this.sourceImg.style.height = 'auto';
        this.sourceImg.style.width = "100%";
        this.sourceImg.style.left = '0'
        this.sourceImg.style.top = (this.parentDom.offsetHeight - this.sourceImg.offsetHeight) / 2 + 'px';
      } else {
        this.sourceImg.style.height = "100%";
        this.sourceImg.style.width = "100%";
        this.sourceImg.style.left = "0";
        this.sourceImg.style.top = "0";
      }
      // this.initCanvas()
    },
    // 处理图片裁剪的位置，大小
    calculate() {
      // 图片比例： 真实图片大小 ： img元素大小
      // 定位问题：拿到左上角的点中心点作为裁剪起始坐标
      // （裁剪框坐标-图片的坐标） *  图片比例
      // 裁剪大小： 裁剪框大小 * 图片比例
      const { topLeft, bottomRight } = this.getTopLeftCoordinate()
      const sourceImg = this.sourceImg
      let realSizi = {
        // 图片真实尺寸
        realWidth: this.realWidth,
        realHeight: this.realHeight
      }

      let imgInfo = {
        // 图片Dom元素显示尺寸, 图片Dom元素显示定位
        width: sourceImg.offsetWidth,
        heigh: sourceImg.offsetHeight,
        top: topLeft.y + this.leftTop.clientWidth / 2,
        left: topLeft.x + this.leftTop.clientWidth / 2,
      }
      // 图片真实尺寸和显示尺寸比例
      let ratioWidth = realSizi.realWidth / imgInfo.width // 宽比例
      let ratioHeight = realSizi.realHeight / imgInfo.heigh // 高比例

      // 裁剪框大小
      const width = bottomRight.x - topLeft.x
      const height = bottomRight.y - topLeft.y

      let result = {
        // 需要的返回结果： 裁剪位置（cx, cy），裁剪大小(cWidth, cHeight)
        cx: imgInfo.left * ratioWidth,
        cy: imgInfo.top * ratioHeight,
        cWidth: width * ratioWidth,
        cHeight: height * ratioHeight,
      }

      return result
    },
    // 执行裁剪（canvas绘画）
    cropping() {
      if (!this.lock) {
        return
      }
      this.lock = false
      let { cx, cy, cWidth, cHeight } = this.calculate()
      const cvs = document.createElement("canvas");
      const ctx = cvs.getContext("2d");
      let picWidth = this.cutSizi.w
      let picHeight = this.cutSizi.h
      if (this.cutSizi.w <= 0) {
        const { topLeft, bottomRight } = this.getTopLeftCoordinate()
        // 裁剪框大小
        picWidth = bottomRight.x - topLeft.x
        picHeight = bottomRight.y - topLeft.y
      }

      cvs.width = picWidth * devicePixelRatio;
      cvs.height = picHeight * devicePixelRatio;
      ctx.drawImage(
        this.$refs.imgRef,
        cx,
        cy,
        cWidth,
        cHeight,
        0,
        0,
        cvs.width,
        cvs.height
      );
      cvs.toBlob((blob) => {
        const file = new File([blob], `${this.picName}.${this.outputType}`, { type: `image/${this.outputType}` });
        // 返回结果
        this.emitFun(file)
        this.lock = true
      });
    },
    // 获取随机字符
    generateRandomString(length) {
      // 定义所有可能的字符
      const characters = '123456789abcdefghijklmnopqrstuvwxyz';
      let result = '';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        // 随机选择一个字符索引，并添加到结果字符串中
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    emitFun(file) {
      this.$emit("resultCallback", file);
    },
  },
};
</script>

<style>
.xz-cutMachine-myCut {
  width: 100%;
  height: 100%;
  user-select: none;
  /* Chrome, Opera, Safari */
  -moz-user-select: none;
  /* Firefox */
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* Internet Explorer */
}

.xz-cutMachine-text {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中 */
  font-size: var(--fontSize);
  color: var(--fontColor);
}

.xz-cutMachine-bogus {
  position: absolute;
  width: var(--BogusW);
  height: var(--BogusH);
  top: var(--BogusY);
  left: var(--BogusX);
  z-index: 40;
  cursor: var(--cursor);
}

.xz-cutMachine-img {
  position: absolute;
}

.xz-cutMachine-canvasRect {
  position: absolute;
  left: 0;
  z-index: 4;
}

.xz-cutMachine-dot {
  display: block;
  width: var(--dotSize);
  height: var(--dotSize);
  border-radius: 50%;
  position: absolute;
  background: var(--dotColor);
  z-index: 1000;
}

.xz-cutMachine-leftTop {
  cursor: var(--cursor14);
}

.xz-cutMachine-rightBottom {
  cursor: var(--cursor14);
}

.xz-cutMachine-rightTop {
  cursor: var(--cursor23);
}

.xz-cutMachine-leftBottom {
  cursor: var(--cursor23);
}

.xz-cutMachine-imgBox {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
